import React from 'react';
function SmallLeftArrow({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M13.75 8.25L10 12l3.75 3.75" />
    </svg>
  );
}

export default SmallLeftArrow;
